import { useId, type ReactNode } from 'react';
import styles from './FormCard.module.css';

interface FormCardProps {
  title: string;
  description?: string;
  children: ReactNode;
}

/** A titled card that groups related fields on the component page. */
export const FormCard = ({ title, description, children }: FormCardProps) => {
  const headingId = useId();

  return (
    <section className={styles.card} aria-labelledby={headingId}>
      <h2 id={headingId}>{title}</h2>
      {description && <p className={styles.description}>{description}</p>}
      {children}
    </section>
  );
};
